import { Stack } from '@mui/material';
import React from 'react';

import { useMedia } from '@/shared/hooks';

interface Props {
  headerName: string;
  children?: React.ReactNode;
}

const PageHeaderLayout: React.FC<Props> = ({
  headerName,
  children
}) => {
  const { isSxScreen } = useMedia();

  return (
    <Stack
      gap={isSxScreen ? '1rem' : ''}
      justifyContent='space-between'
      flexDirection={isSxScreen ? 'column' : 'row'}
      alignItems={isSxScreen ? 'flex-start' : 'center'}
    >
      <h2 style={{ margin: isSxScreen ? '0.5rem 0 0' : '' }}>
        {headerName}
      </h2>

      {children}
    </Stack>
  )
}

export default PageHeaderLayout;